import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BaseComponent} from "../../base/base.component";
import {Apollo} from "apollo-angular";
import {GetChallengeGQL, GetNewGQL, User} from "../../../generated/graphql";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "../../service/user.service";
import {Settings} from "../../settings";

declare var $: any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent extends BaseComponent implements OnInit {
  urlForms = Settings.URL_FORMS;

  user: User;

  constructor(public router: Router,
              public translate: TranslateService,
              public userService: UserService) {
    super(router, translate);
  }

  ngOnInit(): void {
    this.userService.user.subscribe({
      next: data => {
        this.user = data as User;
      }, error: err => {
        console.log('MENU => ', err);
        super.onError(err);
      }
    });
  }

  /**
   * Fecha o menu mobile sem o scroll ancora. O `onNavScroll('')` que existia aqui
   * montava o seletor `$('#')`, que lanca erro no jQuery e ainda redirecionava
   * para a home, competindo com o routerLink.
   */
  closeMenu() {
    $('#header_menu').removeClass('open');
    $('#overlay').removeClass('open');
    $('#header_secondary').removeClass('open');
  }

  navigatorHome() {
    document.querySelector<HTMLElement>('.header').classList.remove('dark');
    this.router.navigate(['/register-idea']);
  }
}
